import { usePageTitle } from "../hooks/usePageTitle";

const PLANS = [
  {
    name: "Practitioner",
    tagline: "Your delivery toolkit for project, change and improvement work.",
    monthly: 59,
    annual: 549,
    features: [
      "Classify and right-size every initiative with CRISP tiering",
      "Manage delivery: WBS, Gantt, RAID register, stakeholders and governance",
      "Manage change: readiness assessment, scorecard, change plan and team responses",
      "Manage improvement: DMAIC lifecycle from Define to Control",
      "Recover at-risk initiatives with the RTG Planner",
      "Export artefacts: Charter, Change Plan, Status Pack, BI Report and more",
      "Portfolio view across all your active initiatives",
      "Quick Learning Guides, Emergency Playbook and 50 AI Coach prompts a month",
    ],
  },
  // Not for sale (claims ladder, 8 Oct 2026): no price, features or subtitle until it ships.
  { name: "Professional", comingSoon: true },
];

const PROFESSIONAL_WAITLIST_HREF = "mailto:hello@groundworktierup.com.au?subject=Professional%20waitlist";

export default function Pricing() {
  usePageTitle("Pricing");
  return (
    <section id="pricing" style={{ maxWidth: 820, margin: "0 auto 4rem", padding: "3.5rem 20px 0" }}>
      <h2 style={{ fontFamily: "var(--font-voice)", fontSize: "clamp(24px, 3.5vw, 32px)", color: "var(--navy)", margin: "0 0 32px", textAlign: "center" }}>
        Pricing
      </h2>
      <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(280px, 1fr))", gap: 24 }}>
        {PLANS.map((plan) => (
          <div
            key={plan.name}
            className="glass-card"
            style={{ padding: "2rem", position: "relative", ...(plan.badge ? { border: "2px solid var(--lilac-deep)" } : {}) }}
          >
            {plan.badge && (
              <span
                style={{ position: "absolute", top: -12, right: 24, background: "var(--lilac-deep)", color: "#fff", fontSize: 11, fontWeight: 700, letterSpacing: "0.06em", textTransform: "uppercase", padding: "4px 12px", borderRadius: 999 }}
              >
                {plan.badge}
              </span>
            )}
            <p style={{ fontFamily: "var(--font-voice)", fontSize: 20, fontWeight: 600, color: "var(--navy)", margin: "0 0 2px" }}>{plan.name}</p>
            {plan.comingSoon ? (
              <>
                <p style={{ fontSize: 28, fontWeight: 700, color: "var(--navy)", margin: "12px 0 24px" }}>Coming soon</p>
                <a
                  href={PROFESSIONAL_WAITLIST_HREF}
                  style={{ display: "block", textAlign: "center", background: "var(--lilac-deep)", color: "#fff", fontSize: 14, fontWeight: 700, padding: "12px 16px", borderRadius: 12, textDecoration: "none" }}
                >
                  Join the waitlist
                </a>
              </>
            ) : (
              <>
                <p style={{ fontSize: 13, color: "var(--text-secondary)", margin: "0 0 12px" }}>{plan.tagline}</p>
                <p style={{ fontSize: 28, fontWeight: 700, color: "var(--navy)", margin: "0 0 4px" }}>
                  ${plan.monthly}
                  <span style={{ fontSize: 14, fontWeight: 400, color: "var(--text-secondary)" }}>/month</span>
                </p>
                <p style={{ fontSize: 13, color: "var(--text-secondary)", margin: "0 0 20px" }}>or ${plan.annual}/year</p>
                <ul style={{ margin: 0, padding: 0, listStyle: "none", fontSize: 14, color: "var(--text-secondary)", lineHeight: 2 }}>
                  {plan.features.map((f) => (
                    <li key={f}>&#10003; {f}</li>
                  ))}
                </ul>
              </>
            )}
          </div>
        ))}
      </div>
      <p style={{ fontSize: 13, color: "var(--text-secondary)", textAlign: "center", margin: "20px 0 0" }}>
        Groundwork Academy is coming to every plan.
      </p>
      <p style={{ fontSize: 13, color: "var(--text-secondary)", textAlign: "center", margin: "8px 0 0" }}>
        All prices in AUD. We&rsquo;re not registered for GST, so no GST is charged.
      </p>
    </section>
  );
}

